import { ApiConstants } from "../../constants/ApiConstants";
import { BILLING_MANAGEMENT_DETAIL, BILLING_MANAGEMENT_LIST } from "../Constants/BillingConstants";
import { createPostDataAction } from "./CommonAction";



export const BillingManagementListAction = (payload: any) => createPostDataAction(BILLING_MANAGEMENT_LIST, ApiConstants?.BillingManagementList, payload, false);
export const BillingManagementDetailAction = (payload: any) => createPostDataAction(BILLING_MANAGEMENT_DETAIL, ApiConstants?.BillingManagementDetail, payload, false);
